class AddToCart extends HTMLElement {
  constructor() {
    super();

    this.button = this.closest("button");
    this.form = this.button?.form;
    this.atcPrice = this.querySelector("[data-atc-price]");

    if (!this.form) return;

    this.onSubmit = (e) => {
      e.preventDefault();

      if (e.target.querySelector("[data-option-indeterminate]")) return;

      this.textContent = window.variantStrings.doingThings;
      this.button.disabled = true;

      const formData = new FormData(this.form);

      const data = {};

      // Add each name/value pair to the object
      for (const [name, value] of formData) {
        const property = /properties\[(?<propertyKey>.+)\]/gm.exec(name);

        if (!property) {
          data[name] = value;
        } else {
          if (!("properties" in data)) {
            data.properties = {};
          }
          data.properties[property.groups.propertyKey] = value;
        }
      }

      if (!("quantity" in data)) {
        data.quantity = 1;
      }

      window.addToCart(data, {
        onAfterAdd: () => {
          document.dispatchEvent(new CustomEvent("mini-cart:open"));
          this.textContent = window.variantStrings.addToCart;
          this.button.disabled = false;
        },
        onError: () => {
          const errorEl = document.createElement("div");
          errorEl.classList.add("add-to-cart-error");
          errorEl.innerHTML = window.variantStrings.addToCartError;

          this.form.append(errorEl);

          this.textContent = window.variantStrings.addToCart;
          this.button.disabled = false;

          setTimeout(() => {
            errorEl.remove();
          }, 4000);
        },
      });
    };

    this.form.addEventListener("submit", this.onSubmit);

    document.addEventListener("aria-listbox:change", () => {
      this.atcPrice.style.display = null;
    });
  }

  disconnectedCallback() {
    this.form?.removeEventListener("submit", this.onSubmit);
  }
}

if (!customElements.get("add-to-cart")) {
  customElements.define("add-to-cart", AddToCart);
}
